import { Button, ButtonProps, Modal } from "react-bootstrap";

interface ConfirmationModalProps {
  show: boolean;
  onCancel: () => void;
  onConfirm: React.MouseEventHandler<HTMLButtonElement>;
  confirmLabel?: string;
  confirmVariant?: ButtonProps["variant"];
  children: React.ReactNode;
}

const ConfirmationModal = ({
  show,
  onCancel,
  onConfirm,
  confirmLabel = "Confirm",
  confirmVariant = "primary",
  children,
}: ConfirmationModalProps) => (
  <Modal show={show} onHide={onCancel} backdrop="static">
    <Modal.Body>{children}</Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onCancel}>
        Cancel
      </Button>
      <Button variant={confirmVariant} onClick={onConfirm}>
        {confirmLabel}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default ConfirmationModal;
